import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const WeeklyAccessCode = ({ onDone, weeklyCode }) => {
  const { t } = useTranslation(['package-room'])
  return (
    <div className="package-room__content package-room__content--full">
      <div className="package-room__access-container">
        <h2 className="package-room__title package-room__title--gray">
          {t('package-room:weeklyAccessCode.title')}
        </h2>
        <p className="package-room__subtitle">{t('package-room:weeklyAccessCode.subtitle')}</p>

        <div className="package-room__code-container">
          <div className="package-room__code">
            {weeklyCode.split('').map((digit, index) => (
              <span key={index} className="package-room__digit">
                {digit}
              </span>
            ))}
          </div>

          <div className="package-room__keypad">
            <img
              src="/images/package-room/keypad.png"
              alt={t('package-room:accessCode.keypadAlt')}
              className="package-room__keypad-image"
            />
          </div>
        </div>
      </div>

      <div className="package-room__action-buttons">
        <button className="package-room__submit-button" onClick={onDone}>
          {t('package-room:accessCode.resetAndStartNew')}
        </button>
      </div>
    </div>
  )
}

WeeklyAccessCode.propTypes = {
  onDone: PropTypes.func.isRequired,
  weeklyCode: PropTypes.string.isRequired,
}

export default WeeklyAccessCode
